import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f41c86a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white-50 p-4" }
const _hoisted_2 = { class: "row mx-4" }
const _hoisted_3 = { class: "row mb-5" }
const _hoisted_4 = { class: "w-max-content col-lg-2 col-form-label fs-9 fw-bold" }
const _hoisted_5 = { class: "row mb-5" }
const _hoisted_6 = { class: "col-lg-8 col-form-label fs-7" }
const _hoisted_7 = { class: "row mb-4" }
const _hoisted_8 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_9 = { class: "col-lg-8 d-lg-flex align-items-center" }
const _hoisted_10 = { class: "input-group mb-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-lg-3 d-flex align-items-center pb-2" }, "～", -1))
const _hoisted_13 = { class: "input-group mb-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_15 = { class: "mb-2 fw-bold fs-16 bg-condition" }
const _hoisted_16 = { class: "row mb-4 px-3 border-bottom pb-4 ms-0" }
const _hoisted_17 = ["id", "value"]
const _hoisted_18 = ["for"]
const _hoisted_19 = { class: "mb-2 fw-bold fs-16 bg-condition" }
const _hoisted_20 = { class: "row mb-4 px-3 border-bottom pb-4 ms-0" }
const _hoisted_21 = ["id", "value"]
const _hoisted_22 = ["for"]

import { computed, onMounted, ref, watch } from 'vue'
import flatPickr from 'vue-flatpickr-component'
import { translate } from '@/languages/i18n'
import { useStore } from 'vuex'
import { CONVERSATIONS_STORE } from '@/store/constants'
import { YELLOOP_CHECK_REJOIN_INTENTION_VALUES, YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES } from '@/constants/index'
import { configDateSearch } from '@/constants/datepicker'


export default /*#__PURE__*/_defineComponent({
  props: {
  resetDataDetail: {
    type: Boolean,
  },
  tabYelloopcheck: {
    type: Boolean,
  },
  filterForAlumni: {
    type: Boolean,
    default: false,
  },
},
  emits: ['formDetail'],
  setup(__props, { emit }) {

const props = __props

const dataSearchDetail = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.GET_DATA_SEARCH_DETAIL])



const store = useStore()

onMounted(() => {
  if (Object.keys(dataSearchDetail.value.yelloop_check).length > 0) {
    YelloopCheckData.value = { ...YelloopCheckData.value, ...dataSearchDetail.value.yelloop_check }
  }
})

const YelloopCheckData = ref({
  yelloop_check_start_period: '',
  yelloop_check_end_period: '',
  rejoin_intention: [],
  desired_information: [],
})

watch(
  () => props.resetDataDetail,
  () => {
    if (props.resetDataDetail) {
      YelloopCheckData.value.yelloop_check_start_period = ''
      YelloopCheckData.value.yelloop_check_end_period = ''
      YelloopCheckData.value.rejoin_intention = []
      YelloopCheckData.value.desired_information = []
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'yelloop_check', data: YelloopCheckData.value })
    }
  }
)

watch(
  () => props.tabYelloopcheck,
  () => {
    if (props.tabYelloopcheck) {
      objChanged()
    }
  }
)



const objChanged = () => {
  let dataSearch = {}
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'yelloop_check', data: YelloopCheckData.value })
  Object.assign(dataSearch, {
    yelloop_check_start_period: YelloopCheckData.value.yelloop_check_start_period,
    yelloop_check_end_period: YelloopCheckData.value.yelloop_check_end_period,
    rejoin_intention: YelloopCheckData.value.rejoin_intention,
    desired_information: YelloopCheckData.value.desired_information,
  })

  emit('formDetail', dataSearch)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitAction && _ctx.submitAction(...args)), ["prevent"])),
    class: "row align-items-center"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)(`OE10YelloopCheckSearch`)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('OE10YelloopCheckSearchTitle')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('OE10YelloopCheckSearchUpdateTime')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(flatPickr), {
                  modelValue: YelloopCheckData.value.yelloop_check_start_period,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((YelloopCheckData.value.yelloop_check_start_period) = $event)),
                  placeholder: "2000/01/01",
                  config: _unref(configDateSearch),
                  class: "form-control bg-white",
                  onChange: objChanged
                }, null, 8, ["modelValue", "config"]),
                _hoisted_11
              ])
            ]),
            _hoisted_12,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(flatPickr), {
                  modelValue: YelloopCheckData.value.yelloop_check_end_period,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((YelloopCheckData.value.yelloop_check_end_period) = $event)),
                  placeholder: "2000/01/01",
                  config: _unref(configDateSearch),
                  class: "form-control bg-white",
                  onChange: objChanged
                }, null, 8, ["modelValue", "config"]),
                _hoisted_14
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(translate)('SA20YelloopCheckRejoinIntentionLabel')), 1),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(YELLOOP_CHECK_REJOIN_INTENTION_VALUES), (label, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "form-check col-md-6 col-12 mb-2 gy-3"
            }, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: 'rejoin_intention_' + key,
                value: key,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((YelloopCheckData.value.rejoin_intention) = $event)),
                onChange: objChanged
              }, null, 40, _hoisted_17), [
                [_vModelCheckbox, YelloopCheckData.value.rejoin_intention]
              ]),
              _createElementVNode("label", {
                class: "form-check-label cursor-pointer",
                for: 'rejoin_intention_' + key
              }, _toDisplayString(label), 9, _hoisted_18)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(translate)('SA20YelloopCheckDesiredInformationLabel')), 1),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES), (label, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "form-check col-md-6 col-12 mb-2 gy-3"
            }, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: 'desired_info_' + key,
                value: key,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((YelloopCheckData.value.desired_information) = $event)),
                onChange: objChanged
              }, null, 40, _hoisted_21), [
                [_vModelCheckbox, YelloopCheckData.value.desired_information]
              ]),
              _createElementVNode("label", {
                class: "form-check-label cursor-pointer",
                for: 'desired_info_' + key
              }, _toDisplayString(label), 9, _hoisted_22)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 32))
}
}

})